import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const StripeMethodApiUtils = {
  addCard(token) {
    return xhr(ApiConstants.Base + 'stripe/card', {
      method: 'post',
      body: JSON.stringify({
        token: token,
      }),
    });
  },

  updateCard(token) {
    return xhr(ApiConstants.Base + 'stripe/card', {
      method: 'put',
      body: JSON.stringify({ token }),
    });
  },

  fetchCard() {
    return xhr(ApiConstants.Base + 'stripe/card');
  },

  //changeDefaultCard(cardId) {
  //  return xhr(ApiConstants.Base + 'stripe/cards/' + cardId + '/set-as-default', {
  //    method: 'put'
  //  });
  //},

  removeCard(cardId) {
    return xhr(ApiConstants.Base + 'stripe/cards/' + cardId, {
      method: 'delete',
    });
  },
};

export default StripeMethodApiUtils;
